import styled from 'styled-components'

export const ContainerExclusiveCommunity = styled.div`
  width: fit-content;
  background-color: var(--yellow-lightest);
  border-radius: 3rem;
  border: 0.063rem solid var(--yellow-light);
`

ContainerExclusiveCommunity.displayName = 'ContainerExclusiveCommunity'

export const ContainerProductCommunity = styled.div`
  width: fit-content;
  background-color: var(--green-lightest);
  border-radius: 3rem;
  border: 0.063rem solid var(--green-light);
`

ContainerProductCommunity.displayName = 'ContainerProductCommunity'

export const ExclusiveCommunity = styled.p`
  color: var(--yellow-darker);
`

ExclusiveCommunity.displayName = 'ExclusiveCommunity'

export const CommunityAsProduct = styled.p`
  color: var(--green-darker);
`

CommunityAsProduct.displayName = 'CommunityAsProduct'

export const ContainerOpenCommunity = styled.div`
  width: fit-content;
  background-color: var(--blue-lightest);
  border-radius: 3rem;
  border: 0.063rem solid var(--blue-light);
`

ContainerOpenCommunity.displayName = 'ContainerOpenCommunity'

export const OpenCommunityLabel = styled.p`
  color: var(--blue-darkest);
`

OpenCommunityLabel.displayName = 'OpenCommunityLabel'

export const ContainerPublicCommunity = styled.div`
  width: fit-content;
  background-color: var(--gray-100);
  border-radius: 3rem;
  border: 0.063rem solid var(--gray-300);
`

ContainerPublicCommunity.displayName = 'ContainerPublicCommunity'

export const PublicCommunityLabel = styled.p`
  color: var(--gray-700);
`

PublicCommunityLabel.displayName = 'PublicCommunityLabel'
